import './hammer';
import 'svg-pan-zoom/dist/svg-pan-zoom';

(function($) {
  /**
   * This var is used to determine panning.
   */
  window.pan_flag = 0;

  /**
   * Appends map controls to each of the SVG Maps
   */
  function appendControls(elem) {
    var resetText = elem.data('reset');
    var ctlControls = $('<div />').addClass('controls');
    var ctlZoomIn = $('<div />').addClass('zoom-in').html('+');
    var ctlReset = $('<div />').addClass('reset').html(resetText);
    var ctlZoomOut = $('<div />').addClass('zoom-out').html('-');

    ctlControls.append(ctlZoomIn).append(ctlReset).append(ctlZoomOut);
    elem.append(ctlControls);
  }

  $(document).ready(function() {
    var map_container = $('#map-container');
    var map = $('#main-campus');
    var zoom = null;

    /**
     * Append map controls
     */
    appendControls(map_container);

    /**
     * Better touch handling code. Copy paste from Hammer.js
     */
    var eventsHandler;
    eventsHandler = {
      haltEventListeners: [
        'touchstart',
        'touchend',
        'touchmove',
        'touchleave',
        'touchcancel'],
      init: function(options) {
        var instance = options.instance;
        var initialScale = 1;
        var pannedX = 0;
        var pannedY = 0;
        // Init Hammer
        // Listen only for pointer and touch events
        /* global Hammer */
        this.hammer = new Hammer(options.svgElement, {
          inputClass: Hammer.SUPPORT_POINTER_EVENTS
              ? Hammer.PointerEventInput
              : Hammer.TouchInput,
        });
        // Enable pinch
        this.hammer.get('pinch').set({enable: true});
        // Handle double tap
        this.hammer.on('doubletap', function() {
          instance.zoomIn();
        });
        // Handle pan
        this.hammer.on('panstart panmove', function(ev) {
          // On pan start reset panned variables
          if (ev.type === 'panstart') {
            pannedX = 0;
            pannedY = 0;
          }
          // Pan only the difference
          instance.panBy({x: ev.deltaX - pannedX, y: ev.deltaY - pannedY});
          pannedX = ev.deltaX;
          pannedY = ev.deltaY;
        });
        // Handle pinch
        this.hammer.on('pinchstart pinchmove', function(ev) {
          // On pinch start remember initial zoom
          if (ev.type === 'pinchstart') {
            initialScale = instance.getZoom();
            instance.zoom(initialScale * ev.scale);
          }
          instance.zoom(initialScale * ev.scale);
        });
        // Prevent moving the page on some devices when panning over SVG
        options.svgElement.addEventListener('touchmove', function(e) {
          e.preventDefault();
        });
      },
      destroy: function() {
        this.hammer.destroy();
      },
    };

    /**
     * Sets the gutters for each SVG map so that you cannot scroll off into the
     * distance
     */
    var beforePan = function(oldPan, newPan) {
      var gutterWidth = 200,
          gutterHeight = 200,
          sizes = this.getSizes(),
          leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) *
              sizes.realZoom) + gutterWidth,
          rightLimit = sizes.width - gutterWidth -
              (sizes.viewBox.x * sizes.realZoom),
          topLimit = -((sizes.viewBox.y + sizes.viewBox.height) *
              sizes.realZoom) + gutterHeight,
          bottomLimit = sizes.height - gutterHeight -
              (sizes.viewBox.y * sizes.realZoom);

      var customPan = {};
      customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x));
      customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y));

      return customPan;
    };

    /**
     * Instantiating map as well as assigning controls
     */
    if (map.length) {
      /* global svgPanZoom */
      zoom = svgPanZoom('#main-campus', {
        fit: true,
        contain: true,
        center: true,
        customEventsHandler: eventsHandler,
        beforePan: beforePan,
      });
      map_container.find('.zoom-in').click(function(e) {
        e.preventDefault();
        zoom.zoomIn();
      });
      map_container.find('.zoom-out').click(function(e) {
        e.preventDefault();
        zoom.zoomOut();
      });
      map_container.find('.reset').click(function(e) {
        e.preventDefault();
        zoom.resetZoom();
        zoom.fit();
        zoom.center();
      });
    }

    /**
     * Create resize function
     */
    var resize = function() {
      if (map.length) {
        zoom.updateBBox();
        zoom.resize();
        zoom.fit();
        zoom.center();
      }
    };

    /**
     * Set page timeout for additional resize since browsers are mean
     */
    setTimeout(resize, 500);

    /**
     * Bind resize to window
     */
    $(window).resize(resize);

    var hover_divs = $('#map-content').find('.map-hover-content');
    if (hover_divs.length) {
      hover_divs.each(function() {
        var hover_div = $(this);
        var svg_region = $('#' + hover_div.data('svg-id'));

        svg_region.mouseenter(function() {
          hover_div.addClass('active');
          svg_region.addClass('hover');
        });
        svg_region.mouseleave(function() {
          hover_div.removeClass('active');
          svg_region.removeClass('hover');
        });
        $(document).mousemove(function(e) {
          hover_div.css({
            'left': (e.clientX + 20) + 'px',
            'top': ((e.clientY) + 'px'),
          });
        });
      });
    }

    var map_services = $('.map-service');
    if (map_services.length) {
      map_services.click(function(e) {
        e.preventDefault();
        var button = $(this);
        map_services.removeClass('active');
        button.addClass('active');
        $('.svg-place').removeClass('active');
        $.each(button.data('svg-ids'), function() {
          $('#' + this).addClass('active');
        });
      });
    }
  });
})(jQuery);
